export { PLPHeroContent, type PLPHeroContentProps } from './PLPHeroContent';
export { default } from './PLPHeroContent';
